export default [
  {
    name: 'root',
    label: 'Wrapper',
    selector: '& ',
  },
  {
    name: 'items',
    label: 'Items',
    selector: '& .items',
  },
  {
    name: 'item',
    label: 'Item',
    selector: '& .item',
  },
  {
    name: 'total',
    label: 'Total Item',
    selector: '& .total',
  },
  {
    name: 'description',
    label: 'Description',
    selector: '& .description',
  },
];
